<template>
  <div class="dld">
    <img src="../assets/images/imggirl.png" />
  </div>

  <div class="justify-content-center flex-column h-100 newbodycardmainpagecls">
    <div class="w-100 text-center mb-5">
      <img src="../assets/images/logo.svg" alt="" />
    </div>

    <div class="card newbodycard o-hidden border-0 shadow-lg">
      <div class="card-body p-0">
        <div class="py-3 px-5">
          <!-- Title -->
          <div class="text-left mb-4">
            <h1 class="m-0">2FA Verification</h1>
            <h2 class="m-0">Enter Code</h2>
          </div>

          <p class="mb-4 text-muted">
            Please enter the 4-digit verification code shared by admin.
          </p>

          <!-- OTP Inputs -->
          <div class="d-flex justify-content-between otp-wrapper mb-4">
            <input
              v-for="(digit, index) in otp"
              :key="index"
              type="text"
              maxlength="1"
              class="form-control otp-box text-center"
              v-model="otp[index]"
              @input="onInput(index, $event)"
              @keydown="onBackspace(index, $event)"
              :ref="(el) => (otpRefs[index] = el)"
            />
          </div>

          <!-- Verify Button -->
          <button
            class="btn btn-primary btn-main btn-user btn-block"
            @click="verifyCode"
            :disabled="loading"
            v-if="loading === false"
          >
            Verify
          </button>

          <button class="btn btn-primary btn-user btn-block" disabled v-else>
            <span class="spinner-border mr-2 spinner-border-sm"></span>
            Verifying...
          </button>
          <div class="text-left mb-2"></div>
          <div class="text-left mb-4">
            <a href="javascript:;" class="m-0" v-on:click="logout">Back to login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  name: "TwoFactor",

  data() {
    return {
      otp: ["", "", "", ""],
      otpRefs: [],
      loading: false,
    };
  },
  mounted() {
    this.$store.state.isLogin = 0;
    $("body").addClass("bg-gradient-primary");
    $("body").addClass("loginbody");
    this.$nextTick(() => {
      if (this.otpRefs[0]) {
        this.otpRefs[0].focus();
      }
    });
  },

  methods: {
    onInput(index, event) {
      const value = event.target.value;

      // ❌ Block non-numeric
      if (!/^[0-9]$/.test(value)) {
        this.otp[index] = "";
        return;
      }

      // 👉 Move to next box
      if (index < 3) {
        event.target.nextElementSibling.focus();
      }

      // 👉 Auto submit if all digits filled
      if (this.otp.join("").length === 4) {
        this.verifyCode();
      }
    },

    onBackspace(index, event) {
      if (event.key === "Backspace" && index > 0 && !this.otp[index]) {
        event.target.previousElementSibling.focus();
      }
    },

    async verifyCode() {
      const code = this.otp.join("");

      if (code.length !== 4) {
        this.$toast.error("Please enter a valid 4-digit code.");
        return;
      }

      this.loading = true;
      const email = localStorage.getItem("email");
      const password = localStorage.getItem("password");
      try {
        // API CALL for OTP verification
        await axios
          .post(process.env.VUE_APP_API_URL + "login", {
            email: email,
            password: password,
            otp: code,
          })
          .then((resp) => {
            if (resp.status == 200 && resp.data.status == "success") {
              localStorage.setItem("mgTasktoken", resp.data.data.token);
              this.$store.state.user.accessToken = resp.data.data.token;
              this.$store.state.user.userInfo = resp.data.data.user;
              this.$store.state.user.roleId = resp.data.data.user.role_id;
              this.$store.state.user.role_name = resp.data.data.user.role_name;
              this.$store.state.isActiveToken = 1;
              this.loginLoader = 1;
              this.$store.state.attemptLogin = 2;
              this.finishLoader();
              // this.$router.push({ name: 'Home' })

              localStorage.removeItem("email");
              localStorage.removeItem("password");
              localStorage.removeItem("need2FA");
              this.$store.state.isLogin = 1;
              this.$router.push({ name: "Home" });
            } else if (resp.status == 200 && resp.data.status == "failure") {
              this.otp = ["", "", "", ""];
              this.$nextTick(() => {
                if (this.otpRefs[0]) {
                  this.otpRefs[0].focus();
                }
              });
              this.loginLoader = 1;
              this.$toast.error(resp.data.message);
            }
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            console.log("response", error.response.status);
            console.log("message", error.response.data.message);
            this.errorRes = error.response.data.message;
          });
      } catch (err) {
        this.$toast.error("Verification failed");
      }

      this.loading = false;
    },
    startLoader() {
      this.$Progress.start();
    },
    finishLoader() {
      this.$Progress.finish();
    },
    async logout() {
      this.otp = ["", "", "", ""]; // 🔥 CLEAR OTP INPUTS

      this.$store.state.user = {
        accessToken: "",
        userInfo: "",
        roleId: "",
      };

      localStorage.clear();

      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped>
.bg-primary {
  background: #0b2c6a !important;
}

.twofa-card {
  width: 320px;
  background: white;
  border-radius: 12px;
}

.otp-wrapper {
  gap: 10px;
}

.otp-box {
  width: 55px;
  height: 55px;
  font-size: 24px;
  border-radius: 8px;
  border: 2px solid #ccc;
  transition: all 0.2s;
}

.otp-box:focus {
  border-color: #ff4d6d;
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 109, 0.25);
}
</style>
